import React from 'react'
import Footer from '../footer/Footer'
import Advert from '../Home/advertPage/Advert'
import GetInTouch from '../Home/getInTouch/GetInTouch'
import NewsLetter from '../Home/newsletter/NewsLetter'
import Navbar from '../navbar/Navbar'
import Hero from './contactShowCase/Hero'


function Contact() {
    return (
        <div>
            <Navbar />
            <Hero />
            <GetInTouch />
            <NewsLetter />
            <Advert />
            <Footer />
        </div>
    )
}

export default Contact
